import React from 'react';

import {
  FilterButton,
  List,
  TopToolbar,
} from 'react-admin';

import {
  Box,
  Card,
} from '@mui/material';

import Pagination from '../../../../layout/Pagination';

import PrefillButton from '../../../utils/PrefillButton';
import { prefillRequest } from './RequestForm';
import { getRequestFilters, RequestListBody } from '../../../../request/RequestList';
import { requestTypes } from '../../../../../constants/requestTypes';

const Requests = ({
  handleOpenChange,
  entities,
  requests,
}: {
  handleOpenChange: () => void;
  entities?: string[];
  requests?: string[];
}) => (
  <List
    filter={{
      id: requests,
    }}
    filterDefaultValues={{
      'custom.entity': entities,
      requestType: requestTypes.TRANSACTION,
    }}
    pagination={<Pagination disableEmptyText />}
    perPage={10}
    filters={getRequestFilters({
      hideSearch: !!requests,
      availableRequestTypes: [requestTypes.TRANSACTION, requestTypes.CAR_PURCHASE],
    })}
    actions={(
      <TopToolbar>
        <FilterButton />
      </TopToolbar>
    )}
    empty={false}
    component={Box}
    resource="requests"
    disableSyncWithLocation
    storeKey={false}
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    <Card variant="outlined">
      <RequestListBody>
        <PrefillButton
          handleOpenChange={handleOpenChange}
          prefillForm={prefillRequest}
        />
      </RequestListBody>
    </Card>
  </List>
);

export default Requests;
